<template>
    <form @submit.prevent="submit">
        <form-input type="text" id="pfnumber" v-model="form.pfnumber" placeholder="PFXXXX" label="Vorgangssuche"
                    @keyup.enter="submit" @cleared="redirect" :error="form.errors.pfnumber" v-if="!active" autocomplete="off"/>

        <div class="sidebar--ask-for-quote" v-if="active">
            <form-input type="text" id="pfnumber" icon="document-edit" v-model="form.pfnumber" placeholder="PFXXXX"
                        label="Vorgangssuche" @keyup.enter="submit" @cleared="redirect" :error="form.errors.pfnumber"
                        closeable="true" @closed="redirect" autocomplete="off"/>
            <div class="submenu">
                <nav>
                    <ul>
                        <li><a :href="clientSketchFile" v-if="clientSketchFile">K-Zeichnung</a></li>
                        <li><a :href="producerSketchFile" v-if="producerSketchFile">P-Zeichnung</a></li>
                        <li><a :href="clientUser" target="_blank" v-if="clientUser">Kundendaten</a></li>
                        <li><a :href="producerUser" target="_blank" v-if="producerUser">Produzentendaten</a></li>
                        <li><a href="#" @click="logbookModal = true">Logbuch</a></li>
                        <li><a href="#" @click="commentsModal = true">Kommentare</a></li>
                        <li><Link :href="this.$$route('dashboard')"> Vorgang schließen </Link></li>
                    </ul>
                </nav>
            </div>
            <ask-for-quote-logbook v-if="logbookModal" @closeDialog="logbookModal = false" :logbook="askForQuote.logbook" />
            <ask-for-quote-comment v-if="commentsModal" @closeDialog="commentsModal = false" :ask-for-quote="askForQuote" />
        </div>
    </form>
</template>

<script>
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import AskForQuoteLogbook from '@partfactory/Pages/Admin/AskForQuote/Modals/AskForQuoteLogbook';
import AskForQuoteComment from '@partfactory/Pages/Admin/AskForQuote/Modals/AskForQuoteComment';

export default {
    name: 'AskForQuoteSidebar',
    components: {AskForQuoteComment, AskForQuoteLogbook, FormInput},
    props: {
        askForQuote: Object,
    },
    data() {
        let logbookModal = false, commentsModal = false;

        const form = useForm({
            'pfnumber': this.askForQuote?.pfnumber ? this.askForQuote?.pfnumber : null,
        });
        return {form, logbookModal, commentsModal};
    },
    computed: {
        active() {
            return !!this.askForQuote;
        },
        clientSketchFile() {
            return this.askForQuote.client_sketch_file ?  this.$$route('sketch-file.download', {'sketchFile': this.askForQuote.client_sketch_file.id}) : null;
        },
        producerSketchFile() {
            return this.askForQuote.producer_sketch_file ?  this.$$route('sketch-file.download', {'sketchFile': this.askForQuote.producer_sketch_file.id}) : null;
        },
        clientUser() {
            return this.askForQuote.client_user ? this.$$route('client-user.edit', {'clientUser': this.askForQuote.client_user.id}) : null;
        },
        producerUser() {
            return this.askForQuote?.producer_order?.producer_user ? this.$$route('producer-user.edit', {'producerUser': this.askForQuote?.producer_order?.producer_user.id}) : null;
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote-search.post'), {});
        },
        redirect() {
            this.$inertia.visit(this.$$route('dashboard'));
        }
    }
};
</script>
